export enum AlertType {
  'Rack Failed Connection' = 1,
  'Reach Critical Level' = 2,
  'Abnormal Consumption' = 3,
  'Shelf Expiry' = 4,
  'Rogue Device' = 5,
}

export enum AlertStatus {
  New = 'new',
  Acknowledged = 'acknowledged',
  Resolved = 'resolved',
}

export enum TAB_ALERTS {
  ALL_TYPES = 1,
  DEVICE_CONNECTION = 2,
  ITEM_EXPIRY = 3,
  REACH_CRITICAL_LEVEL = 4,
  ABNORMAL_CONSUMPTION = 5,
  ROGUE_DEVICE = 6,
}

interface Content {
  consumption?: number;
  itemName?: string;
  itemSku?: string;
  rackName: string;
  threshold?: number;
  wardName: string;
  description: string;
  image?: string;
  macAddress?: string;
}

interface AlertUser {
  id: string;
  username?: string;
}

export interface Alert {
  id: number;
  content: Content;
  time: string;
  is_read: boolean;
  mails: string;
  type: AlertType;
  createdAt: string;
  status: AlertStatus;
  acknowledgedBy?: AlertUser | null;
  acknowledgedAt?: string | null;
  resolvedBy?: AlertUser | null;
  resolvedAt?: string | null;
  resolutionNote?: string | null;
}

export type AlertKey =
  | 'Rack Failed Connection'
  | 'Reach Critical Level'
  | 'Abnormal Consumption'
  | 'Shelf Expiry'
  | 'Rogue Device';

export type AlertGroup = {
  [key in AlertKey]: { total: number; items: Array<Alert> };
};

export interface useLoadMoreAlertsProps {
  alertType: AlertType;
}

export interface AlertsResponse {
  items: Alert[];
  total: number;
}

export interface SuppressionResponse {
  id: number | string;
  name: string;
  sku: string;
  active: boolean;
}
